module.exports = __webpack_public_path__ + "static/NotoSerif-Bold-680cb6030926f83db8a018b85339dd9f.woff";